import React, { useState, useEffect, useRef } from "react";
import { Typography, Checkbox } from "@mui/material";
import moment from "moment";

import { withRouter } from "react-router";
import { compose } from "underscore";
import { connect } from "react-redux";
import { PROFILE } from "../../redux/constant";
import {
  updateProfile,
  getAnnualIncome,
  getBusinessNature,
  getCountry,
  getMaritalStatus,
  getRace,
  getOccupation,
  getStateList,
  getSourceOfFund,
  hideError,
  checkEcddStatus,
  clearError,
  getCustomer,
  acknowledgeCustomer,
} from "../../redux/action";
import { getAllowProfile } from "../redux/actions";

import {
  StepLabel,
  Info,
  Dropdown,
  ProfileDropdown,
  CountryItem,
  DefaultLoader,
  Alert,
  AlertInfo,
  ErrorAlert,
  Tooltip,
  CustomButton,
  AcknowledgeInfoBanner,
  DeeplinkRedirectPopup,
  ProfileUpdateSuccess,
} from "../../../components";
import styles from "../styles";
import { dataLayerGTM } from "../../../utils/functions/dataLayerGTM";
import { getInvestmentObjective } from "../../onBoarding/redux/action";
import { allowedIdType } from "../../../utils/allowedIdType";
import { gatherIdentities } from "../../../utils/functions/gatherIdentities";
import { NO, YES } from "../../../utils/constants";
import {
  getSessionStorageSync,
  removeSessionStorage,
} from "../../../utils/session";

const ProfileInfo = props => {
  const {
    loading,
    isModalOpen,
    errorMessage,
    profile,
    occupationList,
    businessNatureList = [],
    annualIncomeList,
    raceList,
    maritalStatusList,
    countryList,
    stateList,
    getAnnualIncome,
    getBusinessNature,
    getCountry,
    getMaritalStatus,
    getOccupation,
    getRace,
    getStateList,
    getSourceOfFund,
    getInvestmentObjective,
    sourceOfFundList,
    updateProfile,
    checkEcddStatus,
    ecddStatus,
    hideError,
    clearError,
    error,
    history,
    location,
    investmentObjective = [],
    investmentObjectiveLoading,
    allowUpdateProfile,
    getCustomer,
    acknowledgeCustomer,
    getAllowProfile,
  } = props;
  const [nobfilter, setNobFilter] = useState(true);
  const [, setUserInfo] = useState(null);
  const [country, setCountry] = useState([]);
  const [taxCountry, setTaxCountry] = useState([]);
  const [nobListV2, setnobListV2] = useState([]);

  // dropdown state

  const [selectedCountry, setSelectedCountry] = useState("");

  const [selectedTaxCountry, setSelectedTaxCountry] = useState("");

  const [selectedInvestObj, setSelectedInvestObj] = useState("");

  const anchorRef = useRef(null);

  const [showInfo, setShowInfo] = useState(false);
  const [isAcknowledged, setIsAcknowledged] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [acknowledged, setAcknowledged] = useState(false);
  const [showAckSuccess, setShowAckSuccess] = useState(false);
  // Deeplink-only confirmation popup: null | "ack", with a 5s reverse
  // countdown that auto-redirects the customer to their deeplink screen.
  const [deeplinkPopup, setDeeplinkPopup] = useState(null);
  const [redirectCountdown, setRedirectCountdown] = useState(5);
  // Deeplink-only: after the customer updates a field during a required review,
  // show the inline success card (with a Return button) instead of a popup.
  const [showUpdatedCard, setShowUpdatedCard] = useState(false);
  const mustUpdateProfile = Boolean(profile?.showProfileUpdatePrompt);
  const localIdentity = profile?.identities?.find(allowedIdType);

  const [dropdown, setDropdown] = useState({
    sourceOfFundCd: false,
    yearlyIncomeLevelCd: false,
    natureOfBusinessCd: false,
    race: false,
    maritalStatusCd: false,
    occupationTypeCd: false,
    state: false,
  });

  const [dropdownValues, setDropdownValues] = useState({
    sourceOfFundCd: profile?.sourceOfFundCd || "",
    yearlyIncomeLevelCd: profile?.yearlyIncomeLevelCd || "",
    natureOfBusinessCd: profile?.natureOfBusinessCd || "",
    race: profile?.race || "",
    maritalStatusCd: profile?.maritalStatusCd || "",
    occupationTypeCd: profile?.occupationTypeCd || "",
    state:
      profile?.contacts.find(contact => contact.contactTypeCd === "PERMANENT")
        ?.state || "",
  });

  // Deeplink profile-update flow stays on /profile/info without a remount, so
  // dropdownValues (initialized once at mount) would otherwise keep showing the
  // pre-update value. Re-sync it whenever the Redux profile changes (e.g. after
  // the post-update getCustomer refresh) so occupation/income/etc. display the
  // latest saved data. Safe: each field edit dispatches updateProfile
  // immediately, so there is no in-progress local edit to clobber.
  useEffect(() => {
    if (!profile) return;
    setDropdownValues({
      sourceOfFundCd: profile?.sourceOfFundCd || "",
      yearlyIncomeLevelCd: profile?.yearlyIncomeLevelCd || "",
      natureOfBusinessCd: profile?.natureOfBusinessCd || "",
      race: profile?.race || "",
      maritalStatusCd: profile?.maritalStatusCd || "",
      occupationTypeCd: profile?.occupationTypeCd || "",
      state:
        profile?.contacts.find(
          contact => contact.contactTypeCd === "PERMANENT"
        )?.state || "",
    });
  }, [profile]);

  const [idInfo, setIdInfo] = useState({
    idTypeCd: profile?.identities?.find(allowedIdType)?.idTypeCd || "",
    idNumber: localIdentity?.idNo || "", // id card number
    fullName: "",
    dateOfBirth: "",
    country: "",
    cityOfBirth: "",
    gender: "",
    maritalStatus: "",
    race: "",
  });
  const [contactInfo, setContactInfo] = useState({
    contactNumber: "",
    email: "",
    address1: "",
    address2: "",
    address3: "",
    city: "",
    state: "",
    postCode: "",
  });
  const [employmentInfo, setEmploymentInfo] = useState({
    occupation: "",
    industry: "",
    annualIncome: "",
    employerName: "",
  });
  const [otherInfo, setOtherInfo] = useState({
    cashPurpose: "",
    sourceOfFunds: "",
    isPoliticalPosition: NO,
    otherTaxResident: YES,
    taxCountry: "",
    taxId: "",
    isOptInNotification: profile?.optIn ? YES : NO,
    isVc: profile?.isVc ? YES : NO,
    TIN:
      profile?.identities?.find(
        identity =>
          identity.idTypeCd === "TAX" && identity.taxType === "EInvoice"
      )?.idNo || "",
  });

  useEffect(() => {
    // Ensure edit permission is loaded even when the user is deep-linked here
    // directly via the showProfileUpdatePrompt redirect (bypassing /profile).
    getAllowProfile();
    getCountry();
    getMaritalStatus();
    getRace();
    getStateList();
    getOccupation();
    getBusinessNature();
    getAnnualIncome();
    getSourceOfFund();
    getInvestmentObjective();
  }, []);

  useEffect(() => {
    if (profile?.amlHistory[0]?.amlSts === "3") {
      checkEcddStatus(profile?.masterId);
    }
  }, [profile]);

  // Country
  useEffect(() => {
    if (countryList) {
      let sortedName = countryList.sort((a, b) => {
        return a.name < b.name ? -1 : 1;
      });
      let sorted = sortedName.sort((a, b) => {
        return a.index < b.index ? -1 : 1;
      });
      setCountry(sorted);
      setTaxCountry(sorted);
    }
  }, [countryList]);

  useEffect(() => {
    if (profile) {
      setSelectedCountry(
        profile?.identities &&
          profile?.identities.find(allowedIdType)?.citizenship
      );
      setSelectedTaxCountry(
        profile?.identities.find(
          identity =>
            identity?.idTypeCd === "TAX" && identity?.taxType === "CRS"
        )?.citizenship || ""
      );

      setSelectedInvestObj(
        profile?.investmentObjCd ? profile?.investmentObjCd : ""
      );

      setIdInfo(prevState => ({
        ...prevState,
        fullName: profile?.fullName ? profile?.fullName : "",
        dateOfBirth: profile?.dob ? profile?.dob : "",
        cityOfBirth: profile?.townOfBirth ? profile?.townOfBirth : "",
        gender: profile?.gender ? profile?.gender : "",
      }));

      setContactInfo(prevState => ({
        ...prevState,
        contactNumber: profile?.mobileNo ? profile?.mobileNo : "",
        email: profile?.email ? profile?.email : "",
        address1:
          profile?.contacts.length > 0 &&
          profile?.contacts.find(
            contact => contact.contactTypeCd === "PERMANENT"
          ).line1
            ? profile?.contacts.find(
                contact => contact.contactTypeCd === "PERMANENT"
              ).line1
            : "",
        address2:
          profile?.contacts.length > 0 &&
          profile?.contacts.find(
            contact => contact.contactTypeCd === "PERMANENT"
          ).line2
            ? profile?.contacts.find(
                contact => contact.contactTypeCd === "PERMANENT"
              ).line2
            : "",
        address3:
          profile?.contacts.length > 0 &&
          profile?.contacts.find(
            contact => contact.contactTypeCd === "PERMANENT"
          ).line3
            ? profile?.contacts.find(
                contact => contact.contactTypeCd === "PERMANENT"
              ).line3
            : "",
        postCode:
          profile?.contacts.length > 0 &&
          profile?.contacts.find(
            contact => contact.contactTypeCd === "PERMANENT"
          ).postCode
            ? profile?.contacts.find(
                contact => contact.contactTypeCd === "PERMANENT"
              ).postCode
            : "",
        city:
          profile?.contacts.length > 0 &&
          profile?.contacts.find(
            contact => contact.contactTypeCd === "PERMANENT"
          ).city
            ? profile?.contacts.find(
                contact => contact.contactTypeCd === "PERMANENT"
              ).city
            : "",
      }));

      setEmploymentInfo(prevState => ({
        ...prevState,
        employerName: profile?.employerName ? profile?.employerName : "",
      }));

      const CRS = profile?.identities.find(
        identity => identity.idTypeCd === "TAX" && identity.taxType === "CRS"
      );

      setOtherInfo(prevState => ({
        ...prevState,
        cashPurpose:
          profile?.investmentObjCd &&
          investmentObjective.find(
            obj => obj.code === profile?.investmentObjCd
          ) !== undefined
            ? investmentObjective.find(
                obj => obj.code === profile?.investmentObjCd
              ).name
            : "",
        otherTaxResident: CRS ? YES : NO,
        taxId: CRS?.idNo || "",
        // Keep these in sync with the latest profile too (e.g. after the
        // post-update getCustomer refresh) so they don't stay frozen at the
        // mount-time value during the deeplink update flow (no remount).
        isOptInNotification: profile?.optIn ? YES : NO,
        isVc: profile?.isVc ? YES : NO,
        TIN:
          profile?.identities?.find(
            identity =>
              identity.idTypeCd === "TAX" && identity.taxType === "EInvoice"
          )?.idNo || "",
      }));
    }
  }, [profile, investmentObjective]);

  useEffect(() => {
    if (selectedCountry && countryList) {
      if (selectedCountry === "MYS") {
        setIdInfo(prevState => ({
          ...prevState,
          country: "Malaysia",
        }));
      } else if (selectedCountry) {
        setIdInfo(prevState => ({
          ...prevState,
          country: countryList.find(
            countryItem => countryItem.code === selectedCountry
          )
            ? countryList.find(
                countryItem => countryItem.code === selectedCountry
              ).name
            : "",
        }));
      } else {
        setIdInfo(prevState => ({
          ...prevState,
          country: "",
        }));
      }
    }
  }, [selectedCountry, countryList]);

  useEffect(() => {
    if (selectedTaxCountry && countryList) {
      setOtherInfo(prevState => ({
        ...prevState,
        taxCountry: countryList.find(
          countryItem => countryItem.code === selectedTaxCountry
        )
          ? countryList.find(
              countryItem => countryItem.code === selectedTaxCountry
            ).name
          : "",
      }));
    }
  }, [selectedTaxCountry, countryList]);

  useEffect(() => {
    if (dropdownValues.maritalStatusCd && maritalStatusList) {
      setIdInfo(prevState => ({
        ...prevState,
        maritalStatus: maritalStatusList.find(
          maritalSts => maritalSts.code === dropdownValues.maritalStatusCd
        )
          ? maritalStatusList.find(
              maritalSts => maritalSts.code === dropdownValues.maritalStatusCd
            ).name
          : "",
      }));
    }
  }, [dropdownValues.maritalStatusCd, maritalStatusList]);

  useEffect(() => {
    if (dropdownValues.race && raceList) {
      setIdInfo(prevState => ({
        ...prevState,
        race: raceList.find(race => race.code === dropdownValues.race)
          ? raceList.find(race => race.code === dropdownValues.race).name
          : "",
      }));
    }
  }, [dropdownValues.race, raceList]);

  useEffect(() => {
    if (dropdownValues.state && stateList) {
      setContactInfo(prevState => ({
        ...prevState,
        state: stateList.find(
          stateItem => stateItem.code === dropdownValues.state
        )
          ? stateList.find(stateItem => stateItem.code === dropdownValues.state)
              .name
          : "",
      }));
    }
  }, [dropdownValues.state, stateList]);
  const stopOccupations = ["23", "91", "90", "62"];

  useEffect(() => {
    let result = stopOccupations.includes(profile?.occupationTypeCd);
    if (dropdownValues.occupationTypeCd && occupationList) {
      setEmploymentInfo(prevState => ({
        ...prevState,
        occupation: occupationList.find(
          occupation => occupation.code === dropdownValues.occupationTypeCd
        )
          ? occupationList.find(
              occupation => occupation.code === dropdownValues.occupationTypeCd
            ).name
          : "",
      }));
    }
    if (result) {
      setNobFilter(false);
    } else {
      setNobFilter(true);
    }
    if (!allowUpdateProfile) {
      setNobFilter(false);
    }
  }, [dropdownValues.occupationTypeCd, occupationList, allowUpdateProfile]);

  useEffect(() => {
    if (Array.isArray(businessNatureList)) {
      setnobListV2(businessNatureList.filter(item => item.code !== "99"));
    }
  }, [businessNatureList]);

  useEffect(() => {
    if (dropdownValues.natureOfBusinessCd && businessNatureList) {
      setEmploymentInfo(prevState => ({
        ...prevState,
        industry: businessNatureList.find(
          business => business.code === dropdownValues.natureOfBusinessCd
        )
          ? businessNatureList.find(
              business => business.code === dropdownValues.natureOfBusinessCd
            ).name
          : "",
      }));
    }
  }, [dropdownValues.natureOfBusinessCd, businessNatureList]);

  useEffect(() => {
    if (dropdownValues.yearlyIncomeLevelCd && annualIncomeList) {
      setEmploymentInfo(prevState => ({
        ...prevState,
        annualIncome: annualIncomeList.find(
          incomeItem => incomeItem.code === dropdownValues.yearlyIncomeLevelCd
        )
          ? annualIncomeList.find(
              incomeItem =>
                incomeItem.code === dropdownValues.yearlyIncomeLevelCd
            ).description
          : "",
      }));
    }
  }, [dropdownValues.yearlyIncomeLevelCd, annualIncomeList]);

  useEffect(() => {
    if (dropdownValues.sourceOfFundCd && sourceOfFundList) {
      setOtherInfo(prevState => ({
        ...prevState,
        sourceOfFunds: sourceOfFundList.find(
          fund => fund.code === dropdownValues.sourceOfFundCd
        )
          ? sourceOfFundList.find(
              fund => fund.code === dropdownValues.sourceOfFundCd
            ).description
          : "",
      }));
    }
  }, [dropdownValues.sourceOfFundCd, sourceOfFundList]);

  const handleSelectedDropdownValue = name => value => {
    const payload = {
      masterId: profile?.masterId, //R
      email: contactInfo.email, //R
      mobileNo: contactInfo.contactNumber, //R
      fullName: idInfo.fullName, //R
      townOfBirth: idInfo.cityOfBirth, //R
      dob: moment(idInfo.dateOfBirth).format("YYYY-MM-DD"), //R
      investmentObjCd: selectedInvestObj,
      employerName: employmentInfo.employerName,
      optIn: Boolean(profile?.optIn),
      isVc: Boolean(profile?.isVc),
      identities: gatherIdentities(profile, localIdentity),
      address: {
        line1: contactInfo.address1, //R
        line2: contactInfo.address2,
        line3: contactInfo.address3,
        postCode: contactInfo.postCode, //R
        city: contactInfo.city, //R
        state: dropdownValues.state, //R,
        country: selectedCountry, //R
      },
    };

    // mapping each dropdown name to its respective value
    Object.keys(dropdown).forEach(key => {
      // prevent address.state to become root property
      if (key !== "state") {
        payload[key] = dropdownValues[key];
      }
    });

    // overwrite the currently selected value with its newest value
    payload[name] = value;

    // special case, where nested value need to be manually replace
    if (name === "state") {
      payload.address.state = value;
    }

    if (name === "occupationTypeCd" && stopOccupations.includes(value)) {
      payload.natureOfBusinessCd = "99";
    }

    if (payload.isVc) {
      payload.vcDescription = profile?.vcDescription;
    }

    updateProfile({ payloadData: payload, from: PROFILE });

    setDropdown(prev => ({ ...prev, [name]: false }));
  };

  // When the customer reached this page from a deeplink (DeeplinkLP stored the
  // target before detouring here for a required profile review), resume that
  // deeplink after acknowledgement. Rebuilds the same navigation DeeplinkLP
  // would have made: invest/plan -> invest-introduction (state-based),
  // otherwise the /deeplink/:type/:code cash-in screen. Returns false when the
  // customer did not arrive via a deeplink, so normal profile flow is unchanged.
  const resumeDeeplinkAfterProfile = () => {
    const resume = getSessionStorageSync("deeplinkProfileResume");
    if (!resume || !(resume.type || resume.plan)) return false;
    removeSessionStorage("deeplinkProfileResume");

    const { type, code, plan } = resume;
    if (type?.toLowerCase() === "invest" || plan) {
      history.push("/deeplink/invest-introduction", { type, code, plan });
    } else {
      history.push(`/deeplink/${type}/${code}`);
    }
    return true;
  };

  const handleAckSuccessClose = () => {
    setShowAckSuccess(false);
    resumeDeeplinkAfterProfile();
  };

  // Show the deeplink confirmation popup (Case I: acknowledged, Case II:
  // updated a field) and start the 5s reverse countdown from the top.
  const openDeeplinkPopup = variant => {
    setRedirectCountdown(5);
    setDeeplinkPopup(variant);
  };

  // Case II: the customer updated a field instead of acknowledging. The saga
  // flagged the update and routed back here; show the "updated" popup once.
  useEffect(() => {
    const updatedFlag = getSessionStorageSync("deeplinkProfileUpdated");
    const resumeFlag = getSessionStorageSync("deeplinkProfileResume");
    console.log("[PROFILE-UPDATE][Case II] location.key effect", {
      locationKey: location?.key,
      deeplinkProfileUpdated: updatedFlag,
      hasDeeplinkResume: Boolean(resumeFlag),
    });
    if (!updatedFlag) return;
    removeSessionStorage("deeplinkProfileUpdated");
    if (resumeFlag) {
      console.log("[PROFILE-UPDATE][Case II] showing update success card");
      setShowUpdatedCard(true);
      // Refresh the full customer record so the on-screen fields (occupation,
      // income, etc.) and showProfileUpdatePrompt reflect the just-saved update.
      // The PUT response can be partial; /mp/customer is the complete record.
      getCustomer();
    }
  }, [location?.key]);

  // Drive the reverse countdown; on reaching zero, resume the deeplink screen.
  useEffect(() => {
    if (!deeplinkPopup) return undefined;
    if (redirectCountdown <= 0) {
      resumeDeeplinkAfterProfile();
      return undefined;
    }
    const timer = setTimeout(
      () => setRedirectCountdown(prev => prev - 1),
      1000
    );
    return () => clearTimeout(timer);
  }, [deeplinkPopup, redirectCountdown]);

  const handleSave = () => {
    if (!isAcknowledged || isSaving) return;
    setIsSaving(true);
    dataLayerGTM("click_tag", "Click", "Button", "Click Profile Save");
    acknowledgeCustomer(success => {
      setIsSaving(false);
      if (success) {
        setAcknowledged(true);
        // Refresh root customer data so the prompt re-evaluates its visibility.
        getCustomer();
        // Case I: deeplink customers get the auto-redirect popup instead of the
        // standard acknowledgement alert.
        if (getSessionStorageSync("deeplinkProfileResume")) {
          openDeeplinkPopup("ack");
        } else {
          setShowAckSuccess(true);
        }
      }
    });
  };

  const deeplinkPopupText =
    "Thank you for confirming that your information is up to date.";

  return (
    <div style={{ backgroundColor: "#f6f6f8", ...styles.column }}>
      {(loading || investmentObjectiveLoading) && <DefaultLoader />}
      {/* <Alert
        title="Account Verification"
        description="Thank you for submitting your information. Your application is currently being processed. We will notify you once we have completed the verification process."
        isOpen={pendingAlert}
        isCS="https://principal.com.my"
        isCancel={false}
        handleAction={() => setPendingAlert(false)}
        handleCancel={() => setPendingAlert(false)}
      /> */}
      <AlertInfo
        description="We are facing some technical issues, and we are working very hard to resolve the issue."
        isOpen={error === "timeoutError"}
        isTimeout={true}
        handleAction={() => {
          clearError();
          history.push("/profile");
        }}
      />
      <Alert
        title="Acknowledgement Recorded"
        description="Thank you for confirming that your information is up to date."
        isOpen={showAckSuccess}
        isCancel={false}
        btnTxt="Ok"
        handleAction={handleAckSuccessClose}
        handleClose={handleAckSuccessClose}
        okButtonTestId="ack-success-ok"
      />
      {/* Deeplink-only auto-redirect popup (no dismiss button). */}
      <DeeplinkRedirectPopup
        open={deeplinkPopup}
        text={deeplinkPopupText}
        countdown={redirectCountdown}
        onReturn={resumeDeeplinkAfterProfile}
      />
      {/* Dropdown List */}
      {/* Marital Status */}
      <Dropdown
        bottomHeight={({ maxHeight }) => maxHeight * 0.4}
        isOpen={dropdown.maritalStatusCd}
        handleDismiss={() =>
          setDropdown(prev => ({ ...prev, maritalStatusCd: false }))
        }
      >
        <ProfileDropdown
          title="Marital status"
          itemList={maritalStatusList}
          selectedItem={dropdownValues.maritalStatusCd}
          handleClick={handleSelectedDropdownValue("maritalStatusCd")}
        />
      </Dropdown>
      {/* Race */}
      <Dropdown
        bottomHeight={({ maxHeight }) => maxHeight * 0.4}
        isOpen={dropdown.race}
        handleDismiss={() => setDropdown(prev => ({ ...prev, race: false }))}
      >
        <ProfileDropdown
          title="Race"
          itemList={raceList}
          selectedItem={dropdownValues.race}
          handleClick={handleSelectedDropdownValue("race")}
        />
      </Dropdown>
      {/* State */}
      <Dropdown
        bottomHeight={({ maxHeight }) => maxHeight - maxHeight / 10}
        isOpen={dropdown.state}
        handleDismiss={() => setDropdown(prev => ({ ...prev, state: false }))}
      >
        <ProfileDropdown
          title="State"
          itemList={stateList}
          selectedItem={dropdownValues.state}
          handleClick={handleSelectedDropdownValue("state")}
        />
      </Dropdown>
      {/* Occupation */}
      <Dropdown
        bottomHeight={({ maxHeight }) => maxHeight - maxHeight / 10}
        isOpen={dropdown.occupationTypeCd}
        handleDismiss={() =>
          setDropdown(prev => ({ ...prev, occupationTypeCd: false }))
        }
      >
        <ProfileDropdown
          title="Occupation"
          itemList={occupationList}
          selectedItem={dropdownValues.occupationTypeCd}
          handleClick={handleSelectedDropdownValue("occupationTypeCd")}
        />
      </Dropdown>
      {/* Business Nature */}
      <Dropdown
        bottomHeight={({ maxHeight }) => maxHeight - maxHeight / 10}
        isOpen={dropdown.natureOfBusinessCd}
        handleDismiss={() =>
          setDropdown(prev => ({ ...prev, natureOfBusinessCd: false }))
        }
      >
        <ProfileDropdown
          title="Business nature"
          // itemList={businessNatureList.filter(item => item.code !== "99")}
          itemList={nobListV2.length > 0 ? nobListV2 : businessNatureList}
          selectedItem={dropdownValues.natureOfBusinessCd}
          handleClick={handleSelectedDropdownValue("natureOfBusinessCd")}
        />
      </Dropdown>
      {/* Annual Income */}
      <Dropdown
        bottomHeight={({ maxHeight }) => maxHeight * 0.6}
        isOpen={dropdown.yearlyIncomeLevelCd}
        handleDismiss={() =>
          setDropdown(prev => ({ ...prev, yearlyIncomeLevelCd: true }))
        }
      >
        <ProfileDropdown
          title="Annual income"
          itemList={annualIncomeList}
          selectedItem={dropdownValues.yearlyIncomeLevelCd}
          handleClick={handleSelectedDropdownValue("yearlyIncomeLevelCd")}
        />
      </Dropdown>
      {/* Source Of Funds */}
      <Dropdown
        bottomHeight={({ maxHeight }) => maxHeight * 0.6}
        isOpen={dropdown.sourceOfFundCd}
        handleDismiss={() =>
          setDropdown(prev => ({ ...prev, sourceOfFundCd: true }))
        }
      >
        <ProfileDropdown
          title="Source of funds"
          itemList={sourceOfFundList}
          selectedItem={dropdownValues.sourceOfFundCd}
          handleClick={handleSelectedDropdownValue("sourceOfFundCd")}
        />
      </Dropdown>
      {/* Content */}
      {showUpdatedCard ? (
        <ProfileUpdateSuccess onReturn={resumeDeeplinkAfterProfile} />
      ) : (
        mustUpdateProfile && <AcknowledgeInfoBanner />
      )}
      <StepLabel
        title="Profile info"
        containerStyles={{ padding: "16px 16px 22px" }}
        onClick={() => {
          if (mustUpdateProfile) return;
          history.push("/profile");
        }}
        hideBack={mustUpdateProfile}
      />
      {/* Identification Information */}
      <div style={styles.info}>
        <Typography
          color="secondary"
          style={{ ...styles.baseFont, ...styles.caption }}
        >
          Identification information
        </Typography>
      </div>
      <div style={styles.idInfo}>
        <Info label="Full name" value={idInfo.fullName} />
        <Info label="ID number" value={idInfo.idNumber} />
        <Info
          label="Date of birth"
          value={moment(idInfo.dateOfBirth).format("DD/MM/YYYY")}
        />
        <Info label="Country" value={idInfo.country} isEdit={false} />
        <Info
          label="City of birth"
          value={idInfo.cityOfBirth}
          isEdit={allowUpdateProfile}
          onClick={() => {
            dataLayerGTM("click_tag", "Click", "Link", "Edit City of Birth");
            history.push("/profile/info/updateCityOfBirth");
          }}
        />
        <Info
          label="Gender"
          value={
            idInfo.gender
              ? { F: "Female", M: "Male" }[(profile?.gender)] || "Unknown"
              : ""
          }
        />
        <Info
          label="Marital status"
          value={idInfo.maritalStatus}
          isEdit={allowUpdateProfile}
          onClick={() => {
            dataLayerGTM("click_tag", "Click", "Link", "Edit Marital Status");
            setDropdown(prev => ({ ...prev, maritalStatusCd: true }));
          }}
        />
        <Info
          label="Ethnicity / Race"
          value={idInfo.race}
          isEdit={allowUpdateProfile}
          onClick={() => {
            dataLayerGTM("click_tag", "Click", "Link", "Edit Race");
            setDropdown(prev => ({ ...prev, race: true }));
          }}
        />
      </div>
      {/* Contact Information */}
      <div style={styles.info}>
        <Typography
          color="secondary"
          style={{ ...styles.baseFont, ...styles.caption }}
        >
          Contact information
        </Typography>
      </div>
      <div style={styles.idInfo}>
        <Info
          label="Mobile number"
          value={`+${contactInfo.contactNumber.slice(
            0,
            2
          )} ${contactInfo.contactNumber.slice(
            2,
            contactInfo.contactNumber.length
          )}`}
        />
        <Info
          label="Email"
          value={contactInfo.email}
          isEdit={allowUpdateProfile}
          onClick={() => {
            dataLayerGTM("click_tag", "Click", "Link", "Edit Email");
            history.push("/profile/info/updateEmail");
          }}
        />
        <Info
          label="Address"
          value={contactInfo.address1}
          isEdit={allowUpdateProfile}
          onClick={() => {
            dataLayerGTM("click_tag", "Click", "Link", "Edit Address");
            history.push("/profile/info/updateAddress");
          }}
        />
        <Info
          value={contactInfo.address2}
          containerStyle={{ padding: "0 16px" }}
        />
        <Info
          value={contactInfo.address3}
          containerStyle={{ padding: "0 16px" }}
        />

        <Info
          label="Postal code"
          value={contactInfo.postCode}
          isEdit={allowUpdateProfile}
          onClick={() => {
            dataLayerGTM("click_tag", "Click", "Link", "Edit Postal Code");
            history.push("/profile/info/updatePostCode");
          }}
        />

        <div
          style={{
            display: "flex",
            padding: "8px 16px",
            justifyContent: "space-between",
            width: "80%",
          }}
        >
          <div>
            <Typography
              style={{
                fontFamily: "FSElliotPro",
                fontSize: "14px",
                fontWeight: "700",
                lineHeight: 1.57,
              }}
            >
              City
            </Typography>
            <Typography
              style={{
                fontFamily: "FSElliotPro",
                fontSize: "16px",
                fontWeight: "normal",
                lineHeight: 1.5,
              }}
            >
              {contactInfo.city?.replace(
                /\b[A-Z]+\b/g,
                match => match.charAt(0) + match.slice(1).toLowerCase()
              )}
            </Typography>
          </div>
          <div>
            <Typography
              style={{
                fontFamily: "FSElliotPro",
                fontSize: "14px",
                fontWeight: "700",
                lineHeight: 1.57,
              }}
            >
              State
            </Typography>
            <Typography
              style={{
                fontFamily: "FSElliotPro",
                fontSize: "16px",
                fontWeight: "normal",
                lineHeight: 1.5,
              }}
            >
              {contactInfo.state}
            </Typography>
          </div>
        </div>
      </div>
      {/* Employment Information */}
      <div style={styles.info}>
        <Typography
          color="secondary"
          style={{ ...styles.baseFont, ...styles.caption }}
        >
          Employment information
        </Typography>
      </div>
      <div style={styles.idInfo}>
        <Info
          label="Occupation"
          value={employmentInfo.occupation}
          isEdit={allowUpdateProfile}
          onClick={() => {
            dataLayerGTM("click_tag", "Click", "Link", "Edit Occupation");
            setDropdown(prev => ({ ...prev, occupationTypeCd: true }));
          }}
        />
        <Info
          label="Nature of business"
          value={employmentInfo.industry}
          isEdit={nobfilter}
          onClick={() => {
            dataLayerGTM(
              "click_tag",
              "Click",
              "Link",
              "Edit Nature of Business"
            );
            setDropdown(prev => ({ ...prev, natureOfBusinessCd: true }));
          }}
        />
        <Info
          label="Annual income"
          value={employmentInfo.annualIncome}
          isEdit={allowUpdateProfile}
          onClick={() => {
            dataLayerGTM("click_tag", "Click", "Link", "Edit Annual Income");
            setDropdown(prev => ({ ...prev, yearlyIncomeLevelCd: true }));
          }}
        />
        <Info
          label="Employer name"
          value={employmentInfo.employerName}
          isEdit={allowUpdateProfile}
          onClick={() => {
            dataLayerGTM("click_tag", "Click", "Link", "Edit Employer Name");
            history.push("/profile/info/updateEmployerName");
          }}
        />
      </div>
      {/* Other Information */}
      <div style={styles.info}>
        <Typography
          color="secondary"
          style={{ ...styles.baseFont, ...styles.caption }}
        >
          Other information
        </Typography>
      </div>
      <div style={styles.idInfo}>
        <Info
          label="Source of funds"
          value={otherInfo.sourceOfFunds}
          isEdit={allowUpdateProfile}
          onClick={() =>
            setDropdown(prev => ({ ...prev, sourceOfFundCd: true }))
          }
        />
        <Info
          label="Your purpose of investment"
          value={otherInfo.cashPurpose}
          isEdit={allowUpdateProfile}
          onClick={() => {
            dataLayerGTM(
              "click_tag",
              "Click",
              "Link",
              "Edit Purpose of Investment"
            );
            history.push("/profile/info/updateInvestObj");
          }}
        />
        {/* <Info
          label="Do you hold a position (or related to such persons) in any Public or Political offices, Including being its committee or council member"
          value={otherInfo.isPoliticalPosition}
          isEdit={true}
          valueStyle={{ marginTop: "4px" }}
          onClick={() => history.push("/profile/info/isPolitic")}
        /> */}
        <Info
          label="Opt in for e-invoice notification"
          value={otherInfo.isOptInNotification}
          isEdit={allowUpdateProfile}
          valueStyle={{ marginTop: "4px" }}
          onClick={() => {
            dataLayerGTM(
              "click_tag",
              "Click",
              "Link",
              "Edit Tax Identifier Number (TIN)"
            );
            history.push("/profile/info/tin");
          }}
        />

        {!!otherInfo?.TIN && otherInfo.isOptInNotification === YES && (
          <Info
            label="Your Tax Identification Number (TIN) retrieved from the LHDN website"
            value={otherInfo?.TIN}
            valueStyle={{ marginTop: "4px" }}
          />
        )}
        <Info
          label={
            <span style={{ display: "flex", alignItems: "center", gap: "5px" }}>
              <span>Are you a vulnerable client?</span>
              <Tooltip
                copywriting="Someone needing extra support due to disability, major life events, low financial knowledge, or low tech confidence"
                isActive={showInfo}
                callback={e => {
                  const target = e.target;
                  if (target.classList.contains("tooltip-text")) return;
                  setShowInfo(false);
                }}
                tooltipRef={anchorRef}
                additionalClasses="vc"
                anchor={
                  <svg
                    width={22}
                    height={22}
                    viewBox="0 0 22 22"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    ref={anchorRef}
                    style={{
                      position: "relative",
                      top: "4px",
                    }}
                    onClick={() => {
                      setShowInfo(prev => !prev);
                    }}
                  >
                    <path
                      d="M9.99993 9.16658C10.4602 9.16658 10.8333 9.53968 10.8333 9.99991V13.3332C10.8333 13.7935 10.4602 14.1666 9.99993 14.1666C9.53969 14.1666 9.1666 13.7935 9.1666 13.3332V9.99991C9.1666 9.53968 9.53969 9.16658 9.99993 9.16658Z"
                      fill="#0061A0"
                    />
                    <path
                      d="M9.99993 5.83325C9.53969 5.83325 9.1666 6.20635 9.1666 6.66659C9.1666 7.12682 9.53969 7.49992 9.99993 7.49992H10.0083C10.4685 7.49992 10.8416 7.12682 10.8416 6.66659C10.8416 6.20635 10.4685 5.83325 10.0083 5.83325H9.99993Z"
                      fill="#0061A0"
                    />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M0.833252 9.99992C0.833252 4.93731 4.93731 0.833252 9.99992 0.833252C15.0625 0.833252 19.1666 4.93731 19.1666 9.99992C19.1666 15.0625 15.0625 19.1666 9.99992 19.1666C4.93731 19.1666 0.833252 15.0625 0.833252 9.99992ZM9.99992 2.49992C5.85778 2.49992 2.49992 5.85778 2.49992 9.99992C2.49992 14.1421 5.85778 17.4999 9.99992 17.4999C14.1421 17.4999 17.4999 14.1421 17.4999 9.99992C17.4999 5.85778 14.1421 2.49992 9.99992 2.49992Z"
                      fill="#0061A0"
                    />
                  </svg>
                }
              />
            </span>
          }
          value={otherInfo?.isVc}
          isEdit={allowUpdateProfile}
          valueStyle={{ marginTop: "4px" }}
          onClick={() => {
            dataLayerGTM(
              "click_tag",
              "Click",
              "Link",
              "Edit vulnerable client"
            );
            history.push("/profile/info/vc");
          }}
        />
        {profile?.vcDescription && (
          <span
            style={{
              wordWrap: "break-word",
              padding: "0 16px 8px 16px",
              fontFamily: "FSElliotPro",
              fontSize: "16px",
              fontWeight: "normal",
              lineHeight: 1.5,
              color: "#333",
              display: "inline-block",
              marginBottom: "5px",
            }}
          >
            {profile?.vcDescription}
          </span>
        )}

        <Info
          label="Are you a tax resident of any country other than Malaysia?"
          value={otherInfo.otherTaxResident}
          isEdit={allowUpdateProfile}
          valueStyle={{ marginTop: "4px" }}
          onClick={() => {
            dataLayerGTM("click_tag", "Click", "Link", "Edit Tax Resident");
            history.push("/profile/info/taxInfo");
          }}
        />
        {otherInfo.otherTaxResident === YES && (
          <>
            <Info
              label="Tax Country"
              value={otherInfo.taxCountry}
              isEdit={true}
              onClick={() => history.push("/profile/info/taxInfo")}
            />
            <Info
              label="Tax ID Number"
              value={otherInfo.taxId}
              isEdit={true}
              onClick={() => history.push("/profile/info/taxInfo")}
            />
          </>
        )}
      </div>
      <div>
        <Typography style={styles.infoFooter}>
          For any information that cannot be edited within the app, kindly
          contact our Customer Care Centre for assistance.
        </Typography>
      </div>
    
     {mustUpdateProfile && !acknowledged && !showUpdatedCard &&(
        <div
          style={{
            marginTop: "auto",
            position: "sticky",
            bottom: 0,
            width: "100%",
            boxSizing: "border-box",
            backgroundColor: "#fff",
            boxShadow: "0 -4px 16px -8px rgba(0, 0, 0, 0.15)",
            padding: "16px",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "flex-start",
              marginBottom: "16px",
            }}
          >
            <Checkbox
              checked={isAcknowledged}
              onChange={() => setIsAcknowledged(prev => !prev)}
              color="primary"
              disabled={isSaving}
              sx={{
                margin: 0,
                padding: "0px !important",
                paddingTop: "2px",
                "& .MuiSvgIcon-root": { fontSize: 24 },
              }}
              inputProps={{ "data-cy": "profile-acknowledgement" }}
            />
            <Typography
              sx={{
                marginLeft: "10px",
                fontFamily: "FSElliotPro",
                fontSize: "14px",
                lineHeight: 1.29,
                color: "#505050",
              }}
            >
              I have read and acknowledge that my current information with
              Principal Asset Management Berhad is up to date and accurate, and
              I agree to proceed.
            </Typography>
          </div>
          <CustomButton
            text={isSaving ? "Please wait..." : "Save"}
            variant="contained"
            color="#fff"
            backgroundColor="#1278CC"
            disabled={!isAcknowledged || isSaving}
            onClick={handleSave}
            testId="profile-save-btn"
          />
        </div>
      )}
    </div>
  )
};

const withConnect = connect(
  state => ({
    loading: state.goal.loading,
    isModalOpen: state.goal.isModalOpen,
    errorMessage: state.goal.errorMessage,
    profile: state.goal.profile,
    countryList: state.goal.countryList,
    maritalStatusList: state.goal.maritalStatusList,
    raceList: state.goal.raceList,
    occupationList: state.goal.occupationList,
    businessNatureList: state.goal.businessNatureList,
    annualIncomeList: state.goal.annualIncomeList,
    stateList: state.goal.stateList,
    sourceOfFundList: state.goal.sourceOfFundList,
    ecddStatus: state.goal.ecddStatus,
    error: state.goal.error,
    investmentObjective: state.onBoardingReducer.investmentObjective,
    investmentObjectiveLoading:
      state.onBoardingReducer.investmentObjectiveLoading,
    allowUpdateProfile: state.profileReducer.allowUpdateProfile.value,
  }),
  {
    updateProfile,
    getAnnualIncome,
    getBusinessNature,
    getSourceOfFund,
    getCountry,
    getMaritalStatus,
    getOccupation,
    getRace,
    getInvestmentObjective,
    getStateList,
    hideError,
    checkEcddStatus,
    clearError,
    getCustomer,
    acknowledgeCustomer,
    getAllowProfile,
  }
);

export default compose(
  withRouter,
  withConnect
)(ProfileInfo);
